/**
 * EDITOR-KIT — settings for the rich-text editor (react-text-editor-kit).
 *
 * ENABLE_TEXT_EDITOR_KIT
 *   true  → every TinyMCE wrapper (GeneralCkeditor, ckeditor/Ckeditor,
 *           ckeditor/CkeditorWebsiteSetting, EmailContentEditor) shows the
 *           React Editor Kit instead.
 *   false → the old TinyMCE editor comes back everywhere (quick revert).
 *
 * TEXT_EDITOR_KIT_API_KEY
 *   Comes only from REACT_APP_TEXT_EDITOR_KIT_API_KEY in the .env file
 *   (.env.bms-gym-dev / -stage / -prod). Restart the app after adding it.
 *   No key → the old TinyMCE editor is shown (nothing breaks).
 *
 * IMAGE_UPLOAD_PATH — same S3 upload API the TinyMCE editor used.
 */
export const ENABLE_TEXT_EDITOR_KIT = true;

export const TEXT_EDITOR_KIT_API_KEY = (
  process.env.REACT_APP_TEXT_EDITOR_KIT_API_KEY || ""
).trim();

export const USE_TEXT_EDITOR_KIT =
  ENABLE_TEXT_EDITOR_KIT && Boolean(TEXT_EDITOR_KIT_API_KEY);

export const IMAGE_UPLOAD_PATH = "app/update_image_on_s3";
